"use client";
/*
 * Documentation:
 * OW_Project_Hero — https://app.subframe.com/4f62853ee923/library?component=OW_Project_Hero_f7e71a04-bbcd-47d4-99d9-c221d379ac27
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Ow_Project_HeroRootProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  brandElementSlot?: React.ReactNode;
  className?: string;
}

const Ow_Project_HeroRoot = React.forwardRef<
  HTMLDivElement,
  Ow_Project_HeroRootProps
>(function Ow_Project_HeroRoot(
  {
    title,
    description,
    brandElementSlot,
    className,
    ...otherProps
  }: Ow_Project_HeroRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "w-full items-center overflow-hidden rounded-md bg-brandsecondary-700 px-16 relative grid grid-cols-1 md:grid-cols-2",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex flex-col items-start gap-12 py-32 z-10">
        {title ? (
          <span className="text-heading-1 font-heading-1 text-white">
            {title}
          </span>
        ) : null}
        {description ? (
          <span className="text-body font-body text-white">{description}</span>
        ) : null}
      </div>
      {brandElementSlot ? (
        <div className="flex flex-col items-center justify-end gap-12 self-stretch absolute top-0 bottom-0 right-0 z-0 mobile:hidden">
          {brandElementSlot}
        </div>
      ) : null}
    </div>
  );
});

export const Ow_Project_Hero = Ow_Project_HeroRoot;
